import React from "react";
import Header from "./Header";
import PqrsdAdminList from "../pqrsd/PqrsdAdminList";

export default function LayoutPqrsdMine() {
  return (
    <>
      <Header />
      <PqrsdAdminList scope="mine" />
    </>
  );
}
